/**
 * @nettrek/c2pa-web-crypto
 *
 * A dependency-free, WebCrypto-based C2PA reader/verifier for fragmented BMFF
 * (HLS/DASH) assets. Implements the subset of the @contentauth/c2pa-web reader
 * surface that @nettrek/c2pa-hls-bridge consumes (createC2pa → reader.fromBlob /
 * reader.fromBlobFragment producing a c2pa-types ManifestStore), with no WASM.
 */

export const VERSION = '0.1.1'

export { createC2pa } from './createC2pa'
export type { C2paSdk, ReaderFactory, Config, Settings, TrustSettings } from './createC2pa'
export type { Reader, ReaderInput } from './reader/Reader'
export type {
    ManifestStore,
    Manifest,
    ManifestAssertion,
    Ingredient,
    SignatureInfo,
    ClaimGeneratorInfo,
    ResourceRef,
    ValidationStatus,
    ValidationResults,
    ValidationState,
    SigningAlg
} from './types'
